const controlCommonAreas = () => {
    const groupSelector = '.commonareas_group'; 

    if (groupSelector) {        
        let isUserInteracted = false;

        // console.log('isUserInteracted')
        // console.log(isUserInteracted)
        
        function updateAllGroupVisibility() {
            if (!isUserInteracted) return; // Skip before interaction
            
            const activeActionTypes = new Set();

            document.querySelectorAll('.wp-block-accordion-item').forEach(accordionItem => {
                if (accordionItem.classList.contains('is-open')) {
                    const actionButton = accordionItem.querySelector('.commonareas_actionbutton');
                    if (actionButton) {
                        for (let cls of actionButton.classList) {
                            if (cls.startsWith('commonareas_action--')) {
                                const actionType = cls.split('--')[1];
                                activeActionTypes.add(actionType);
                                break;
                            }
                        }
                    }
                }
            });

            if (activeActionTypes.size === 0) {
                document.querySelectorAll(groupSelector).forEach(group => {
                    group.style.display = 'block';
                    group.classList.add('visible');
                });
                return;
            }

            document.querySelectorAll(groupSelector).forEach(group => {
                let groupActionType = '';
                for (let cls of group.classList) {
                    if (cls.startsWith('commonareas_group--')) {
                        groupActionType = cls.split('--')[1];
                        break;
                    }
                }

                const shouldShow = activeActionTypes.has(groupActionType);
                group.style.display = shouldShow ? 'block' : 'none';
                group.classList.toggle('visible', shouldShow);
            });
        }

        // Observe class changes on all accordion items
        const observer = new MutationObserver((mutations) => {


            mutations.forEach(mutation => {
                if (mutation.target.classList && 
                    mutation.target.classList.contains('wp-block-accordion-item')) {
                    
                    isUserInteracted = true;
                    
                    updateAllGroupVisibility();
                }
            });
        }, { attributes: true, attributeFilter: ['class'] });

        setTimeout(() => {
            document.querySelectorAll('.wp-block-accordion-item').forEach(item => {
                observer.observe(item, { attributes: true, attributeFilter: ['class'] });
            });
        }, 200)
    }
}

export { controlCommonAreas }